import { IconLens } from "@reactlens/icons";
import { ThemeToggle } from "../ThemeToggle.js";

const REPO = "https://github.com/Fausto95/react-lens";

function IconGitHub() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" aria-hidden>
      <path d="M8 0C3.58 0 0 3.58 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82.64-.18 1.32-.27 2-.27s1.36.09 2 .27c1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.01 8.01 0 0 0 16 8c0-4.42-3.58-8-8-8z" />
    </svg>
  );
}

export function SiteNav() {
  return (
    <header className="site-nav">
      <div className="site-nav-inner">
        <a className="site-nav-brand" href="#hero">
          <IconLens size={18} />
          <span>React Lens</span>
        </a>
        <nav className="site-nav-links" aria-label="Page">
          <a href="#time-travel">Rewind</a>
          <a href="#why">Trace</a>
          <a href="#cascade">Cascade</a>
          <a href="#diff">Diff</a>
          <a href="#agents">Agents</a>
        </nav>
        <div className="site-nav-actions">
          <div className="site-nav-embed" data-rl-embed-controls />
          <ThemeToggle />
          <a
            className="github-toggle"
            href={REPO}
            target="_blank"
            rel="noreferrer"
            aria-label="React Lens on GitHub"
            title="GitHub"
          >
            <IconGitHub />
          </a>
        </div>
      </div>
    </header>
  );
}
